import React, { useEffect, useState } from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import CssBaseline from "@mui/material/CssBaseline";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import useMediaQuery from "@mui/material/useMediaQuery";
import logo from "../assets/logo2.png";
import Cookies from "js-cookie";
import toast from "react-hot-toast";
import ApartmentIcon from "@mui/icons-material/Apartment";

import { Popover, Transition } from "@headlessui/react";
import { useLocation, useNavigate } from "react-router-dom";
import { IoIosArrowDown } from "react-icons/io";
import { FaRegUser } from "react-icons/fa";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import CleanHandsIcon from "@mui/icons-material/CleanHands";
import PaidIcon from "@mui/icons-material/Paid";
import BuildIcon from "@mui/icons-material/Build";
import CloseIcon from "@mui/icons-material/Close";
import { FaUserCheck } from "react-icons/fa6";

import {
  SESSION_IS_AUTHENTICATED,
  SESSION_USERINFO,
} from "../Utills/Constants";

const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open" && prop !== "isMobile",
})(({ theme, open, isMobile }) => ({
  position: "fixed !important",
  top: isMobile ? 4 : 8,
  right: isMobile ? 4 : 8,
  left: isMobile ? 4 : "auto",
  zIndex: theme.zIndex.drawer + 1,
  width: isMobile
    ? "calc(100% - 8px)"
    : open
    ? `calc(100% - ${drawerWidth}px - 16px)`
    : `calc(100% - ${theme.spacing(8)} - 1px - 16px)`,
  marginLeft: isMobile
    ? 0
    : open
    ? drawerWidth
    : `calc(${theme.spacing(8)} + 1px)`,
  background: "transparent !important",
  boxShadow: "none !important",
  transition: isMobile
    ? "none"
    : theme.transitions.create(["width", "margin-left"], {
        easing: theme.transitions.easing.sharp,
        duration: open
          ? theme.transitions.duration.enteringScreen
          : theme.transitions.duration.leavingScreen,
      }),
}));

const DesktopDrawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

const NAV_COLORS = {
  bg: "#E3ECF6",
  border: "#BBD6F5",
  icon: "#2F6DB4",
  iconBg: "#e0f5ee",
  label: "#2F6DB4",
  bar: "#2F6DB4",
};

const navItems = [
  {
    label: "New Purchase Medicine",
    path: "/account/addpurchase",
    activePaths: ["/account/addpurchase", "/account/addpurchase/add"],
    icon: Inventory2Icon,
  },
  {
    label: "Medicine Stock",
    path: "/account/medicinestock",
    activePaths: ["/account/medicinestock", "/account/medicinestock/add"],
    icon: Inventory2Icon,
  },
  {
    label: "Lab Test",
    path: "/account/Labtest/labtest",
    activePaths: ["/account/Labtest/labtest", "/account/Labtest/labtest/add"],
    icon: Inventory2Icon,
  },
  {
    label: "Medical Services",
    path: "/account/medicalservices",
    activePaths: ["/account/medicalservices", "/account/medicalservices/add"],
    icon: Inventory2Icon,
  },
  {
    label: "Medicine Sales",
    path: "/account/sales",
    activePaths: ["/account/sales", "/account/sales/add"],
    icon: Inventory2Icon,
  },
  {
    label: "Service Sales",
    path: "/account/servicesales",
    activePaths: ["/account/servicesales", "/account/servicesales/add"],
    icon: Inventory2Icon,
  },
  {
    label: "Patient Sales",
    path: "/account/patientsales",
    activePaths: ["/account/patientsales", "/account/patientsales/add"],
    icon: Inventory2Icon,
  },
  {
    label: "Income",
    path: "/account/income",
    activePaths: ["/account/income", "/account/income/AddEditIncome"],
    icon: CleanHandsIcon,
  },
  {
    label: "Expense",
    path: "/account/expense",
    activePaths: ["/account/expense", "/account/expense/add"],
    icon: PaidIcon,
  },
  {
    label: "Equipments",
    path: "/account/equipment",
    activePaths: [
      "/account/equipment",
      "/account/equipment/add",
      "/account/equipment/update",
    ],
    icon: BuildIcon,
  },
  {
  label: "Hospital Structure",
  path: "/account/hospitalstructure",
  activePaths: [
    "/account/hospitalstructure",
    "/account/hospitalstructure/add",
    "/account/hospitalstructure/update",
  ],
  icon: ApartmentIcon,
},
{
  label: "Attendence",
  path: "/account/Attendence",
  activePaths: [
    "/account/Attendence",
    // "/account/Attendence/add",
    // "/account/Attendence/update",
  ],
  icon: FaUserCheck,
},
];

function SidebarContent({ open, location, navigate, onNavClick }) {
  return (
    <>
      <div className="relative flex items-center justify-center px-3 border-b border-gray-100 mb-2">
        <img
          src={logo}
          alt="logo"
          className={`object-contain transition-all duration-300 ${open ? "w-48 h-48" : "w-22 h-22"}`}
        />
      </div>

      {open && (
        <p className="text-[10px] font-bold tracking-[1.2px] uppercase pt-2 text-gray-400 px-5 pb-1 m-0">
          Navigation
        </p>
      )}

      <nav className="py-1" style={{ overflowY: "auto", overflowX: "hidden" }}>
        {navItems.map((item) => {
          const isActive = item.activePaths.includes(location.pathname);
          return (
            <NavItem
              key={item.path}
              icon={item.icon}
              label={item.label}
              isActive={isActive}
              open={open}
              onClick={() => {
                navigate(item.path);
                if (onNavClick) onNavClick();
              }}
              color={NAV_COLORS}
            />
          );
        })}
      </nav>
    </>
  );
}

export default function PortalLayout({ children }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [open, setOpen] = useState(true);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const handleLogout = () => {
    localStorage.removeItem("user");
    Cookies.remove("Q0FUSU9OOQUNVU1RPTUVSLUFVVEhFTlRJIMSLQ1JFVC1LR=");
    toast.success("Logout Successfully");
    navigate("/login", { replace: true });
  };

  if (location.pathname === "/" || location.pathname === "/login")
    return children;

  const activeItem = navItems.find((item) =>
    item.activePaths.includes(location.pathname)
  );
  const pageTitle = activeItem?.label ?? "Dashboard";

  const drawerPaperSx = {
    border: "none",
    borderTopRightRadius: 12,
    borderBottomRightRadius: 12,
    background: "#ffffff",
    boxShadow: "6px 0 32px rgba(0,0,0,0.10)",
    overflow: "hidden",
    zIndex: 9999,
  };

  return (
    <div className="flex items-stretch min-h-screen bg-slate-100">
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap'); * { font-family: 'Plus Jakarta Sans', sans-serif; }`}</style>
      <CssBaseline />

      <AppBar open={open} isMobile={isMobile}>
        <div className="rounded-2xl border border-white/70 bg-white/85 backdrop-blur-xl shadow-[0_4px_24px_rgba(0,0,0,0.08)]">
          <Toolbar className="!min-h-[56px] !px-3">
            <IconButton
              onClick={() => isMobile ? setMobileOpen(!mobileOpen) : setOpen(!open)}
              edge="start"
              className="!mr-2 !w-9 !h-9 !rounded-xl !bg-gray-700/[0.07] hover:!bg-gray-700/[0.14] !transition-colors"
            >
              <MenuIcon className="!text-[20px] !text-gray-700" />
            </IconButton>

            <div className="ml-2 min-w-0 flex-1">
              <p className="text-[15px] font-bold text-gray-700 m-0 leading-tight truncate">
                {pageTitle}
              </p>
              <p className="text-[11px] text-gray-400 m-0">
                {new Date().toLocaleDateString("en-US", {
                  weekday: "long",
                  month: "short",
                  day: "numeric",
                })}
              </p>
            </div>

            <div className="ml-auto flex items-center gap-3 flex-shrink-0">
              <Popover className="relative">
                <Popover.Button
                  as="div"
                  onClick={() => setIsPopoverOpen(!isPopoverOpen)}
                  className="flex items-center gap-2 px-3 py-[6px] rounded-full cursor-pointer select-none
                    bg-gradient-to-r from-[#2F6DB4] via-[#5894d9] to-white/90
                    shadow-[0_2px_12px_rgba(0,0,0,0.2)]
                    hover:shadow-[0_4px_20px_rgba(0,0,0,0.3)] transition-shadow duration-200"
                >
                  <AccountCircleIcon className="!text-[20px] !text-white/90" />
                  <IoIosArrowDown
                    className="w-3.5 h-3.5 text-white/70 transition-transform duration-300"
                    style={{
                      transform: isPopoverOpen ? "rotate(-180deg)" : "rotate(0deg)",
                    }}
                  />
                </Popover.Button>

                <Transition
                  as={React.Fragment}
                  enter="transition ease-out duration-150"
                  enterFrom="opacity-0 -translate-y-2"
                  enterTo="opacity-100 translate-y-0"
                  leave="transition ease-in duration-100"
                  leaveFrom="opacity-100 translate-y-0"
                  leaveTo="opacity-0 -translate-y-2"
                >
                  <Popover.Panel
                    className="absolute top-[calc(100%+10px)] right-0 z-[9999]
                      min-w-[220px] rounded-2xl overflow-hidden
                      bg-white/[0.97] backdrop-blur-xl
                      border border-gray-700/10
                      shadow-[0_20px_60px_rgba(0,0,0,0.15)]"
                  >
                    <div className="flex items-center gap-2.5 p-4 bg-gradient-to-r from-[#2F6DB4] via-[#5894d9] to-white/90">
                      <div className="w-9 h-9 rounded-full bg-white/20 flex items-center justify-center flex-shrink-0">
                        <FaRegUser className="text-white text-base" />
                      </div>
                      <div>
                        <p className="text-white/60 text-[11px] m-0">Accounts</p>
                      </div>
                    </div>

                    <div
                      onClick={handleLogout}
                      className="flex items-center gap-2.5 m-2.5 px-3.5 py-2.5 rounded-xl cursor-pointer
                        bg-gradient-to-r from-red-500 to-red-600
                        text-white font-semibold text-[13px]
                        shadow-[0_3px_12px_rgba(239,68,68,0.3)]
                        hover:-translate-y-px hover:shadow-[0_6px_18px_rgba(239,68,68,0.4)]
                        transition-all duration-200"
                    >
                      <PowerSettingsNewIcon className="!text-[18px]" />
                      <span>Sign Out</span>
                    </div>
                  </Popover.Panel>
                </Transition>
              </Popover>
            </div>
          </Toolbar>
        </div>
      </AppBar>

      {isMobile && (
        <>
          <div
            className={`fixed inset-0 z-[9998] bg-black/40 backdrop-blur-sm transition-opacity duration-300 ${
              mobileOpen ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
            }`}
            onClick={() => setMobileOpen(false)}
          />

          <div
            className={`fixed top-0 left-0 h-full z-[9999] bg-white shadow-2xl flex flex-col transition-transform duration-300 ease-in-out ${
              mobileOpen ? "translate-x-0" : "-translate-x-full"
            }`}
            style={{ width: drawerWidth, borderTopRightRadius: 12, borderBottomRightRadius: 12, overflow: "hidden" }}
          >
            <div className="flex items-center justify-end p-2 border-b border-gray-100">
              <IconButton
                onClick={() => setMobileOpen(false)}
                className="!w-8 !h-8 !rounded-lg !bg-gray-100 hover:!bg-gray-200"
              >
                <CloseIcon className="!text-[18px] !text-gray-600" />
              </IconButton>
            </div>

            <div className="flex-1 overflow-y-auto">
              <SidebarContent
                open={true}
                location={location}
                navigate={navigate}
                onNavClick={() => setMobileOpen(false)}
              />
            </div>
          </div>
        </>
      )}

      {!isMobile && (
        <DesktopDrawer
          variant="permanent"
          open={open}
          sx={{
            "& .MuiDrawer-paper": drawerPaperSx,
          }}
        >
          <SidebarContent
            open={open}
            location={location}
            navigate={navigate}
          />
        </DesktopDrawer>
      )}

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 0,
          width: isMobile ? "100%" : "auto",
        }}
      >
        <DrawerHeader />
        <div
          className="bg-gradient-to-br from-gray-50 to-gray-100 min-h-[calc(100vh-80px)] rounded-2xl shadow-[0_2px_16px_rgba(0,0,0,0.06)]"
          style={{
            padding: isMobile ? "8px" : "16px",
            margin: isMobile ? "0 4px 4px 4px" : "0 8px 8px 0",
          }}
        >
          {children}
        </div>
      </Box>
    </div>
  );
}

function NavItem({ icon: Icon, label, isActive, open, onClick, color }) {
  const c = color ?? {
    bg: "#f3f4f6",
    border: "#d1d5db",
    icon: "#6b7280",
    iconBg: "#f3f4f6",
    label: "#374151",
    bar: "#6b7280",
  };

  return (
    <div
      onClick={onClick}
      title={!open ? label : ""}
      className={[
        "relative flex items-center cursor-pointer rounded-xl overflow-hidden",
        "mx-2 my-[2px] px-[10px] py-[8px]",
        "border transition-all duration-200",
      ].join(" ")}
      style={
        isActive
          ? {
              background: c.bg,
              borderColor: c.border,
              boxShadow: `0 2px 8px ${c.icon}22`,
            }
          : {
              background: "transparent",
              borderColor: "transparent",
            }
      }
      onMouseEnter={(e) => {
        if (!isActive) {
          e.currentTarget.style.background = "#f8f9fa";
          e.currentTarget.style.borderColor = "#e5e7eb";
        }
      }}
      onMouseLeave={(e) => {
        if (!isActive) {
          e.currentTarget.style.background = "transparent";
          e.currentTarget.style.borderColor = "transparent";
        }
      }}
    >
      <div
        className="flex items-center justify-center w-[32px] h-[32px] rounded-[8px] flex-shrink-0 transition-all duration-200"
        style={
          isActive
            ? { background: c.icon }
            : { background: "#f1f3f5", border: "1px solid #e5e7eb" }
        }
      >
        <Icon
          sx={{ fontSize: 17 }}
          style={{
            fontSize: 17,
            color: isActive ? "#fff" : "#6b7280",
          }}
        />
      </div>

      <span
        className={[
          "ml-[10px] text-[13px] font-semibold whitespace-nowrap overflow-hidden transition-all duration-300 flex-1",
          open ? "max-w-[160px] opacity-100" : "max-w-0 opacity-0",
        ].join(" ")}
        style={{ color: isActive ? c.label : "#4b5563" }}
      >
        {label}
      </span>

      {isActive && (
        <div
          className="absolute right-0 top-1/2 -translate-y-1/2 w-[3px] h-[55%] rounded-l"
          style={{ background: c.bar }}
        />
      )}
    </div>
  );
}